var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 718.3 306.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        mask: url(#mask-5);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #c4733b;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-9 {\r\n        mask: url(#mask-1);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-12 {\r\n        mask: url(#mask-10);\r\n      }\r\n\r\n      .cls-13 {\r\n        mask: url(#mask-6);\r\n      }\r\n\r\n      .cls-14 {\r\n        mask: url(#mask-7);\r\n      }\r\n\r\n      .cls-15 {\r\n        filter: url(#luminosity-noclip-5);\r\n      }\r\n\r\n      .cls-16 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .cls-19 {\r\n        mask: url(#mask-8);\r\n      }\r\n\r\n      .cls-20 {\r\n        filter: url(#luminosity-noclip-11);\r\n      }\r\n\r\n      .cls-21 {\r\n        mask: url(#mask-2);\r\n      }\r\n\r\n      .cls-22 {\r\n        filter: url(#luminosity-noclip-3);\r\n      }\r\n\r\n      .cls-23 {\r\n        mask: url(#mask-9);\r\n      }\r\n\r\n      .cls-24 {\r\n        opacity: .2;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #3d1900;\r\n      }\r\n\r\n      .cls-27 {\r\n        filter: url(#luminosity-noclip-9);\r\n      }\r\n\r\n      .cls-28 {\r\n        opacity: .2;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#linear-gradient-4);\r\n        opacity: .3;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #42210b;\r\n      }\r\n\r\n      .cls-32 {\r\n        mask: url(#mask-11);\r\n      }\r\n\r\n      .cls-33 {\r\n        mask: url(#mask-4);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-35 {\r\n        filter: url(#luminosity-noclip-7);\r\n      }\r\n\r\n      .cls-36 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-37 {\r\n        mask: url(#mask-3);\r\n      }\r\n\r\n      .cls-38 {\r\n        filter: url(#luminosity-noclip);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 359.1,
    y1: 302.8,
    x2: 359.1,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#512100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#692e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#954500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a64e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a74f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#aa5508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b16014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bb6f25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c7823b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d79b56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9b775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd79a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd99c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M613.7,302.8H102.8c-42.2,0-77.7-31.6-82.7-73.5L4.6,96.9c-2.8-23.6,4.7-47.3,20.5-65C40.8,14.2,63.5,4,87.2,4h543.8c24,0,46.8,10.3,62.6,28.3,15.8,18,23.1,42,20,65.7l-17.4,132.4c-5.4,41.3-40.9,72.4-82.5,72.4ZM87.2,52c-10.2,0-19.6,4.2-26.3,11.8-6.8,7.6-9.9,17.4-8.7,27.5l15.6,132.4c2.1,17.7,17.1,31.1,35,31.1h510.9c17.6,0,32.6-13.2,34.9-30.6l17.4-132.4c1.3-10.2-1.7-20.1-8.4-27.8-6.8-7.7-16.2-12-26.5-12H87.2Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 359.1,
    cy: 153.4,
    fx: 359.1,
    fy: 153.4,
    r: 250.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e67e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d67320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1631e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 28.1,
    y: 28,
    width: 662.2,
    height: 128.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 28.1,
    y: -8353.2,
    width: 662.2,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 28.1,
    y: -8353.2,
    width: 662.2,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 359.1,
    y1: 156.8,
    x2: 359.1,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 28.1,
    y: 28,
    width: 662.2,
    height: 128.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M631.1,28H87.2c-35,0-62.1,30.1-58.9,64.7,73.8,38.8,194.6,64.1,331.2,64.1s256.6-25.1,330.4-63.7c3.5-34.7-23.7-65.1-58.9-65.1Z"
  })))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 132,
    y: 254.8,
    width: 454.2,
    height: 7.6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 132,
    y: -8353.2,
    width: 454.2,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 132,
    y: -8353.2,
    width: 454.2,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 132,
    y1: 258.6,
    x2: 586.2,
    y2: 258.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 132,
    y: 254.8,
    width: 454.2,
    height: 7.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 132,
    y: 254.8,
    width: 454.2,
    height: 7.6
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 132,
    y1: 258.6,
    x2: 586.2,
    y2: 258.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 588.9,
    y: 52,
    width: 21.4,
    height: 21.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 588.9,
    y: -8353.2,
    width: 21.4,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 588.9,
    y: -8353.2,
    width: 21.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3667.7,
    y1: 73.4,
    x2: 3667.7,
    y2: 52,
    gradientTransform: "translate(2070.2 3423.3) rotate(-112.7) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 588.9,
    y: 52,
    width: 21.4,
    height: 21.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 599.6,
    cy: 62.7,
    r: 10.7,
    transform: "translate(310.8 591.9) rotate(-67.3)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3667.7,
    y1: 73.4,
    x2: 3667.7,
    y2: 52,
    gradientTransform: "translate(2070.2 3423.3) rotate(-112.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc395"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 110.6,
    y: 52,
    width: 21.4,
    height: 21.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 110.6,
    y: -8353.2,
    width: 21.4,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 110.6,
    y: -8353.2,
    width: 21.4,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 4146,
    y1: 73.4,
    x2: 4146,
    y2: 52,
    gradientTransform: "translate(1850.8 3831.3) rotate(-113.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 110.6,
    y: 52,
    width: 21.4,
    height: 21.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 121.3,
    cy: 62.7,
    r: 10.7,
    transform: "translate(15 148.4) rotate(-66.2)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 4146,
    x2: 4146,
    gradientTransform: "translate(1850.8 3831.3) rotate(-113.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 618.6,
    y: 53.9,
    width: 44.3,
    height: 33.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 618.6,
    y: -8353.2,
    width: 44.3,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 618.6,
    y: -8353.2,
    width: 44.3,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3626.6,
    y1: 87,
    x2: 3626.6,
    y2: 53.9,
    gradientTransform: "translate(4267.3) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 618.6,
    y: 53.9,
    width: 44.3,
    height: 33.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M619.5,60.3c-3.4,7.2,3.3,17.6,15,23.2,11.7,5.6,24,4.3,27.5-2.9,3.4-7.2-3.3-17.6-15-23.2-11.7-5.6-24-4.3-27.5,2.9Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 3626.6,
    y1: 87,
    x2: 3626.6,
    y2: 53.9,
    gradientTransform: "translate(4267.3) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 56.1,
    y: 53.4,
    width: 39.1,
    height: 39.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 56.1,
    y: -8353.2,
    width: 39.1,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 56.1,
    y: -8353.2,
    width: 39.1,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3005.7,
    y1: 3872.3,
    x2: 3042.6,
    y2: 3885.3,
    gradientTransform: "translate(-977.4 4877.2) rotate(-25.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 56.1,
    y: 53.4,
    width: 39.1,
    height: 39.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 75.6,
    cy: 72.9,
    rx: 23.5,
    ry: 14.5,
    transform: "translate(-29.4 74.8) rotate(-45)"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3005.7,
    y1: 3872.3,
    x2: 3042.6,
    y2: 3885.3,
    gradientTransform: "translate(-977.4 4877.2) rotate(-25.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orange_x5F_button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M613.7,302.8H102.8c-42.2,0-77.7-31.6-82.7-73.5L4.6,96.9c-2.8-23.6,4.7-47.3,20.5-65C40.8,14.2,63.5,4,87.2,4h543.8c24,0,46.8,10.3,62.6,28.3,15.8,18,23.1,42,20,65.7l-17.4,132.4c-5.4,41.3-40.9,72.4-82.5,72.4ZM87.2,52c-10.2,0-19.6,4.2-26.3,11.8-6.8,7.6-9.9,17.4-8.7,27.5l15.6,132.4c2.1,17.7,17.1,31.1,35,31.1h510.9c17.6,0,32.6-13.2,34.9-30.6l17.4-132.4c1.3-10.2-1.7-20.1-8.4-27.8-6.8-7.7-16.2-12-26.5-12H87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M631.1,4c24,0,46.8,10.3,62.6,28.3,15.8,18,23.1,42,20,65.7l-17.4,132.4c-5.4,41.3-40.9,72.4-82.5,72.4H102.8c-42.2,0-77.7-31.6-82.7-73.5L4.6,96.9c-2.8-23.6,4.7-47.3,20.5-65C40.8,14.2,63.5,4,87.2,4h543.8M102.8,254.8h510.9c17.6,0,32.6-13.2,34.9-30.6l17.4-132.4c1.3-10.2-1.7-20.1-8.4-27.8-6.8-7.7-16.2-12-26.5-12H87.2c-10.2,0-19.6,4.2-26.3,11.8-6.8,7.6-9.9,17.4-8.7,27.5l15.6,132.4c2.1,17.7,17.1,31.1,35,31.1M631.1,0H87.2C62.3,0,38.6,10.7,22,29.3,5.5,47.9-2.3,72.7.6,97.4l15.6,132.4c5.2,43.9,42.4,77,86.6,77h510.9c43.6,0,80.8-32.6,86.5-75.9l17.4-132.4c3.3-24.9-4.4-50-20.9-68.9-16.6-18.9-40.5-29.7-65.6-29.7h0ZM102.8,250.8c-15.8,0-29.2-11.9-31-27.6l-15.6-132.4c-1.1-9,1.7-17.6,7.7-24.4,6-6.8,14.3-10.5,23.3-10.5h543.8c9.1,0,17.5,3.8,23.5,10.6,6,6.9,8.7,15.6,7.5,24.7l-17.4,132.4c-2,15.5-15.3,27.2-31,27.2H102.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 53.5,
    width: 819.1,
    height: 12.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 29.9,
    width: 819.1,
    height: 12.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 120.8,
    width: 819.1,
    height: 12.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 169.5,
    width: 819.1,
    height: 12.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 148.2,
    width: 819.1,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 231.7,
    width: 819.1,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 254.5,
    width: 819.1,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 275.4,
    width: 819.1,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 83.7,
    width: 819.1,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4,
    y: 196.9,
    width: 819.1,
    height: 19.3
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M613.7,284.8H102.8c-33.1,0-60.9-24.8-64.8-57.6l-15.6-132.4c-2.2-18.5,3.7-37.1,16-51,12.4-13.9,30.1-21.9,48.7-21.9h543.8c18.8,0,36.6,8.1,49,22.2,12.4,14.1,18.1,32.9,15.6,51.5l-17.4,132.4c-4.2,32.4-32,56.7-64.7,56.7ZM87.2,34c-15.2,0-29.7,6.5-39.8,17.9-10.1,11.3-14.9,26.5-13.1,41.6l15.6,132.4c3.1,26.8,25.9,47,52.9,47h510.9c26.6,0,49.3-19.9,52.8-46.3l17.4-132.4c2-15.2-2.7-30.5-12.8-42-10.1-11.5-24.7-18.1-40-18.1H87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M613.7,278.8H102.8c-30,0-55.3-22.5-58.8-52.3l-15.6-132.4c-4.1-35.2,23.4-66.1,58.8-66.1h543.8c35.8,0,63.4,31.5,58.7,66.9l-17.4,132.4c-3.9,29.5-29,51.5-58.7,51.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M631.1,44c12.4,0,24.3,5.4,32.5,14.7,8.2,9.4,12,21.8,10.4,34.1l-17.4,132.4c-2.8,21.4-21.2,37.6-42.9,37.6H102.8c-21.9,0-40.4-16.4-42.9-38.2l-15.6-132.4c-1.4-12.2,2.4-24.6,10.6-33.8,8.2-9.2,20-14.5,32.3-14.5h543.8M631.1,28H87.2c-35.5,0-63,30.9-58.8,66.1l15.6,132.4c3.5,29.8,28.8,52.3,58.8,52.3h510.9c29.7,0,54.9-22,58.7-51.5l17.4-132.4c4.7-35.5-23-66.9-58.7-66.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M631.1,28H87.2c-35,0-62.1,30.1-58.9,64.7,73.8,38.8,194.6,64.1,331.2,64.1s256.6-25.1,330.4-63.7c3.5-34.7-23.7-65.1-58.9-65.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 132,
    y: 254.8,
    width: 454.2,
    height: 7.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 599.6,
    cy: 62.7,
    r: 10.7,
    transform: "translate(310.8 591.9) rotate(-67.3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 121.3,
    cy: 62.7,
    r: 10.7,
    transform: "translate(15 148.4) rotate(-66.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M619.5,60.3c-3.4,7.2,3.3,17.6,15,23.2,11.7,5.6,24,4.3,27.5-2.9,3.4-7.2-3.3-17.6-15-23.2-11.7-5.6-24-4.3-27.5,2.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 75.6,
    cy: 72.9,
    rx: 23.5,
    ry: 14.5,
    transform: "translate(-29.4 74.8) rotate(-45)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentButton);
export default __webpack_public_path__ + "static/media/assessment_button.ca2de0e3f032694223071e3258a6af86.svg";
export { ForwardRef as ReactComponent };